export interface VariantTemplate {
  description?: string;
  /** Effective persisted variant domain supplied by the backend for report selection. */
  domain?: string;
  name: string;
  variantPatches: string[];
}

/**
 * Type guard that asserts whether a value conforms to the VariantTemplate shape.
 *
 * @param obj - The object to check
 * @returns true if the object is a VariantTemplate, false otherwise
 */
export const isVariantTemplate = (obj: unknown): obj is VariantTemplate => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;

  // Check basic props
  const chkObj = obj as VariantTemplate;
  if (typeof chkObj.name !== "string") return false;
  if (!["string", "undefined"].includes(typeof chkObj.description)) return false;
  if (chkObj.domain !== undefined && typeof chkObj.domain !== "string") return false;
  if (
    !Array.isArray(chkObj.variantPatches) ||
    chkObj.variantPatches.some((x) => typeof x !== "string")
  )
    return false;

  // Everything is good
  return true;
};
